/* eslint-disable no-console */
import Vue from 'vue'

const Debugger = (state) => {
    return {
        debug: state
            ? console.debug.bind(console, '%c[DEBG]', 'background: #000; color: #da55bb')
            : () => {},
        info: state
            ? console.info.bind(console, '%c[INFO]', 'background: #000; color: #55da95')
            : () => {},
        warn: state
            ? console.warn.bind(console, '%c[WARN]', 'background: #000; color: #bada55')
            : () => {},
        error: state
            ? console.error.bind(console, '%c[ERRO]', 'background: #000; color: #da6455')
            : () => {},
    }
}
const temporarilyOff = true

window.debug = Vue.prototype.$debug = Debugger(
    process.env.NODE_ENV !== 'production' && process.env.VUE_APP_DEBUG && !temporarilyOff
)

export default Debugger
